module.exports = __webpack_public_path__ + "static/media/mask-group-9.94dbeb50.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mask-group-9.png
// module id = 1295
// module chunks = 1